import { createAction, createReducer } from "@reduxjs/toolkit";

export const fetchAll = createAction("PARTNERS_FETCH_ALL");

const initialState = {
  partners: [],
};

const partnersReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchAll, (state, action) => {
    state.partners = action.payload;
  });
});

export default partnersReducer;

export const partnersActions = {
  fetchAll,
};
